function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgModDtfSingleDesign = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 31.468 31.946"
    },
    viewBox: "0 0 31.468 31.946",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.527 11.386V2.131a.867.867 0 0 0-.867-.867H2.305a.867.867 0 0 0-.867.867v17.355c0 .479.388.867.867.867h8.678",
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.982 14.823-4.756 3.456a.164.164 0 0 1-.252-.183l1.817-5.591L3.036 9.05c-.128-.093-.062-.296.097-.296H9.01l1.817-5.59a.163.163 0 0 1 .311 0l1.817 5.59h5.878c.159 0 .225.203.096.296l-3.26 2.368-4.687-.032",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.205 30.476H11.85a.867.867 0 0 1-.867-.867V12.254a.865.865 0 0 1 .867-.867h17.355c.479 0 .867.388.867.867v17.355a.867.867 0 0 1-.867.867z",
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.697 13.328 1.803 5.547h5.833c.173 0 .245.221.105.323l-4.721 3.429 1.803 5.548c.053.164-.135.301-.274.199l-4.719-3.43-4.719 3.43a.178.178 0 0 1-.274-.199l1.803-5.548-4.719-3.429a.179.179 0 0 1 .105-.323h5.833l1.803-5.547c.052-.164.284-.164.338 0z",
    style: {
      fill: "#222"
    }
  }));
};
export default SvgModDtfSingleDesign;